import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Navigate } from 'src/app/models/navigate';

@Injectable({
    providedIn: 'root',
})
export class NavigationStateService {
    private onAskNavigate = new BehaviorSubject<Navigate>(null);
    private onNavigate = new BehaviorSubject<Navigate>(null);

    /**
     * Emet un événement lorsque l'on demande la navigation.
     */
    public askNavigate(navigate: Navigate): void {
        this.onAskNavigate.next(navigate);
    }

    /**
     * Recupère la demande de navigation
     */
    public get onAskNavigate$(): Observable<Navigate> {
        return this.onAskNavigate.asObservable();
    }

    /**
     * Emet un événement pour la navigation
     */
    public navigate(navigate: Navigate): void {
        this.onNavigate.next(navigate);
    }

    /**
     * Recupére l'information de navigation
     */
    public get navigate$(): Observable<Navigate> {
        return this.onNavigate.asObservable();
    }
}
